import { useTranslation } from 'react-i18next';
import TextInput from '__components/Inputs/TextInput';

type ApiNameInputProps = {
  value?: string | null;
  className?: string;
};

export const ApiNameInput = ({ value, className }: ApiNameInputProps) => {
  const { t } = useTranslation();

  return (
    <TextInput
      value={value}
      label={t('API Name')}
      labelInfoPlacement="top"
      placeholder={t('API Name')}
      data-qa="smartconnector-api_name-input"
      margin
      disabled
      className={className}
    />
  );
};
